<div class="map">
  <app-corporate-map [listings]="listings" [employees]="employees" [bookings]="bookings"></app-corporate-map>
</div>
